/* eslint-disable import/no-anonymous-default-export */
export default {
	styleOverrides: {
		root: {
			lineHeight: '2em',
		},
	},
};
